import { InjectionToken, Provider } from '@angular/core';
import { ApimAuthenticationApiService } from '../apim-authentication.api.service';
import { APIMAuthenticationRepository } from '../apim-authentication.repository';

export const HTTP_APIM_AUTHENTICATION_SERVICE = new InjectionToken<APIMAuthenticationRepository>('APIMAuthenticationRepository');

export const APIM_AUTHENTICATION_API_PROVIDER: Provider = {
    provide: HTTP_APIM_AUTHENTICATION_SERVICE,
    useClass: ApimAuthenticationApiService,
};
